import styled from "@emotion/styled";
import Button from "@components/Button";
import { MoneyInput } from "@components/mask-components";
import { useTranslations } from "next-intl";
import React from "react";
interface AlbumFooterProps {
  data: any;
  onTourClick: () => void;
  minimum_price: string | null;
  maximum_price: string | null;
  price: string;
}

const AlbumFooter = ({
  data,
  onTourClick,
  minimum_price,
  maximum_price,
  price,
}: AlbumFooterProps) => {
  const t = useTranslations("PriceRange");

  return (
    <Footer>
      {Boolean(data.realstate_tour_url) && (
        <AlbumButton onClick={onTourClick}>Matterport</AlbumButton>
      )}
      <AlbumTag className={data.alternate_price > 0 ? "price-double" : ""}>
        {data.alternate_price > 0 && (
          <>
            <AlbumPrice>
              <AlbumPriceTag className="price-double">VENTA</AlbumPriceTag>
              <AlbumPriceNumber className="price-double">
                <MoneyInput
                  value={data.price}
                  prefix={data.currency.symbol + "$"}
                  displayType="text"
                />
              </AlbumPriceNumber>
            </AlbumPrice>

            <AlbumPrice>
              <AlbumPriceTag className="price-double">ALQUILER</AlbumPriceTag>
              <AlbumPriceNumber className="price-double">
                <MoneyInput
                  value={data.alternate_price}
                  prefix={data.alternative_currency.symbol + "$"}
                  displayType="text"
                />
              </AlbumPriceNumber>
            </AlbumPrice>
          </>
        )}

        {data.alternate_price <= 0 && (
          <AlbumPrice>
            <AlbumPriceTag>{data.business_type}</AlbumPriceTag>
            <AlbumPriceNumber>
              {maximum_price && minimum_price ? (
                <>
                  <PriceRangeItem>
                    {t("from")}{" "}
                    <PriceRangeItemPrice>{minimum_price}</PriceRangeItemPrice>
                  </PriceRangeItem>
                  <PriceRangeItem>
                    {t("to")}{" "}
                    <PriceRangeItemPrice>{maximum_price}</PriceRangeItemPrice>
                  </PriceRangeItem>
                </>
              ) : (
                price
              )}
            </AlbumPriceNumber>
          </AlbumPrice>
        )}
      </AlbumTag>
    </Footer>
  );
};

const Footer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  transform: translateY(2.5rem);

  @media screen and (max-width: 991px) {
    flex-direction: column;
  }
  @media screen and (max-width: 1000px) {
    transform: translateY(0);
  }
  @media screen and (max-width: 570px) {
    transform: none;
  }
`;

const AlbumButton = styled(Button)`
  background-color: #969daf;
  width: 169px;
  height: 36px;
  font-size: 1rem;
  font-weight: 400;
  text-transform: none;
  line-height: 1.15;
  padding: 0;
  margin: auto 0.7rem;
  transform: translateX(15px);

  @media screen and (max-width: 400px) {
    transform: translateX(0);
  }

  &:hover {
    background-color: #969daf;
    scale: 1;
  }

  @media screen and (max-width: 991px) {
    border-radius: 0 0 10px 10px;
    margin: 0;
  }
`;

const AlbumTag = styled.div`
  width: 18rem;
  height: auto;
  background-color: var(--color-brand-bg-secondary);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border-radius: 20px;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 570px) {
    border-radius: 0 0 20px 20px;
  }
  &.price-double {
    min-height: 106px;
    padding: 10px 20px;
    gap: 10px 20px;
  }
  @media screen and (max-width: 991px) {
    width: 100%;
    margin-top: 30px;
    border-radius: 20px;
  }
`;

const AlbumPrice = styled.p`
  flex: 1;
`;

const AlbumPriceTag = styled.span`
  display: block;
  font-size: 1.2rem;
  font-weight: 300;
  text-transform: uppercase;
  color: black;
  &.price-double {
    font-size: ${14 / 12 + "rem"};
  }
`;

const AlbumPriceNumber = styled.span`
  font-size: 1.7rem;
  font-weight: 500;
  display: block;
  color: black;
  &.price-double {
    font-size: ${16 / 12 + "rem"};
  }
`;

const PriceRangeItem = styled.p`
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 2px;
  text-transform: uppercase;

  @media (max-width: 500px) {
    font-size: 15px;
  }
`;

const PriceRangeItemPrice = styled.span`
  font-weight: 700;
  font-size: 1.4rem;

  @media (max-width: 500px) {
    font-size: 1.2rem;
  }
`;

export default AlbumFooter;
